import { useEffect, useState } from "react";
import { Col, Container, Row, Card, Badge } from "react-bootstrap";
import axios from "axios";
import { BASE_URL } from "../../App";
import ScrollTopButton from "../ScrollTop";
import SidebarProfile from "../SidebarProfile";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUserCheck, faUserTimes, faGraduationCap, faChartLine, faCalendarCheck, faCalendarTimes } from "@fortawesome/free-solid-svg-icons";
import '../../styles/profile.css';
import BinocularsLoader from "../BinocularsLoader";

function ProfileAttendance({ style, auth }) {
    const [attendanceData, setAttendanceData] = useState(null);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        window.scrollTo(0, 0);

        const fetchAttendanceData = async () => {
            setIsLoading(true);

            const token = localStorage.getItem('token');
            const delay = new Promise(resolve => setTimeout(resolve, 2000)); // تأخير 2 ثانية

            try {
                // الحصول على بيانات المستخدم أولاً
                const [authRes] = await Promise.all([
                    axios.get(`${BASE_URL}/api/Auth`, {
                        headers: { 'Authorization': `Bearer ${token}` }
                    }),
                    delay
                ]);
                
                console.log('Auth Prop:', auth);
                console.log('Auth Response:', authRes.data);
                
                // استخدام ID من استجابة Auth
                const userId = authRes.data.id;
                
                if (userId) {
                    // إعادة جلب بيانات الحضور بالـ ID الصحيح
                    const attendanceResponse = await axios.get(`${BASE_URL}/api/student-profile/${userId}`, {
                        headers: { 'Authorization': `Bearer ${token}` }
                    });
                    
                    console.log('Attendance API Response:', attendanceResponse.data);
                    setAttendanceData(attendanceResponse.data.data);
                } else {
                    console.error("User ID not found in auth response");
                }
            } catch (error) {
                console.error("Failed to fetch attendance data:", error);
            } finally {
                setIsLoading(false);
            }
        };

        fetchAttendanceData();
    }, []);

    // حساب الإحصائيات
    const calculateStats = () => {
        if (!attendanceData?.courses_by_category) return { totalCourses: 0, attendedCourses: 0, absentCourses: 0, averageGrade: 0 };

        let totalCourses = 0;
        let attendedCourses = 0;
        let absentCourses = 0;
        let totalGrades = 0;
        let coursesWithGrades = 0;

        attendanceData.courses_by_category.forEach(category => {
            category.courses.forEach(course => {
                totalCourses++;
                if (course.attendance_status === 'حاضر') {
                    attendedCourses++;
                } else if (course.attendance_status === 'غائب') {
                    absentCourses++;
                }
                
                if (course.exam_grade && course.exam_grade !== null) {
                    totalGrades += parseInt(course.exam_grade);
                    coursesWithGrades++;
                }
            });
        });

        const averageGrade = coursesWithGrades > 0 ? Math.round(totalGrades / coursesWithGrades) : 0;

        return { totalCourses, attendedCourses, absentCourses, averageGrade };
    };

    const stats = calculateStats();
    const attendancePercentage = stats.totalCourses > 0 ? Math.round((stats.attendedCourses / stats.totalCourses) * 100) : 0;

    if (isLoading) {
        return (
            <div className={`main-loading ${style ? 'dark-mode' : ''}`}>
                <div className="loading-course">
                    <BinocularsLoader style={style} />
                </div>
            </div>
        );
    }

    return (
        <>
            <div className={`profile-page ${style ? 'dark-mode' : ''}`}>
                <SidebarProfile />
                <main className="profile-main-content">
                    <Container fluid>
                        <div className="page-header">
                            <div className="header-icon-wrapper">
                                <FontAwesomeIcon icon={faUserCheck} />
                            </div>
                            <div className="header-text">
                                <h1>الغياب والحضور</h1>
                                <p>تتبع حضورك وغيابك في جميع الكورسات مع درجات الامتحانات.</p>
                                {attendanceData?.student && (
                                    <div className="student-info mt-3">
                                        <p><strong>الطالب:</strong> {attendanceData.student.name}</p>
                                        <p><strong>المستوى:</strong> {
                                            attendanceData.student.level === 2 ? 'الصف الثالث الثانوي احصاء' :
                                            attendanceData.student.level === 3 ? 'الصف الثالث الثانوي رياضة' :
                                            `المستوى ${attendanceData.student.level}`
                                        }</p>
                                        <p><strong>المجموعة:</strong> {attendanceData.student.group}</p>
                                    </div>
                                )}
                            </div>
                        </div>

                        {/* إحصائيات عامة */}
                        <Row className="mb-4">
                            <Col md={3} sm={6} className="mb-3">
                                <Card className="attendance-stat-card">
                                    <Card.Body>
                                        <div className="stat-icon attended">
                                            <FontAwesomeIcon icon={faUserCheck} />
                                        </div>
                                        <h4>{stats.attendedCourses}</h4>
                                        <p>حضور</p>
                                    </Card.Body>
                                </Card>
                            </Col>
                            <Col md={3} sm={6} className="mb-3">
                                <Card className="attendance-stat-card">
                                    <Card.Body>
                                        <div className="stat-icon absent">
                                            <FontAwesomeIcon icon={faUserTimes} />
                                        </div>
                                        <h4>{stats.absentCourses}</h4>
                                        <p>غياب</p>
                                    </Card.Body>
                                </Card>
                            </Col>
                            <Col md={3} sm={6} className="mb-3">
                                <Card className="attendance-stat-card">
                                    <Card.Body>
                                        <div className="stat-icon percentage">
                                            <FontAwesomeIcon icon={faChartLine} />
                                        </div>
                                        <h4>{attendancePercentage}%</h4>
                                        <p>نسبة الحضور</p>
                                    </Card.Body>
                                </Card>
                            </Col>
                            <Col md={3} sm={6} className="mb-3">
                                <Card className="attendance-stat-card">
                                    <Card.Body>
                                        <div className="stat-icon grade">
                                            <FontAwesomeIcon icon={faGraduationCap} />
                                        </div>
                                        <h4>{stats.averageGrade}</h4>
                                        <p>متوسط الدرجات</p>
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>

                        {/* جدول الحضور */}
                        <div className="attendance-table-container">
                            <div className="attendance-table-header">
                                <div className="table-header-cell">
                                    <FontAwesomeIcon icon={faCalendarCheck} />
                                    <span>التاريخ</span>
                                </div>
                                <div className="table-header-cell">
                                    <FontAwesomeIcon icon={faUserCheck} />
                                    <span>المجموعة</span>
                                </div>
                                <div className="table-header-cell">
                                    <FontAwesomeIcon icon={faGraduationCap} />
                                    <span>الدرجة</span>
                                </div>
                                <div className="table-header-cell">
                                    <FontAwesomeIcon icon={faChartLine} />
                                    <span>التقدم</span>
                                </div>
                                <div className="table-header-cell">
                                    <FontAwesomeIcon icon={faUserTimes} />
                                    <span>النوع</span>
                                </div>
                                <div className="table-header-cell">
                                    <FontAwesomeIcon icon={faUserCheck} />
                                    <span>الحالة</span>
                                </div>
                                <div className="table-header-cell">
                                    <FontAwesomeIcon icon={faGraduationCap} />
                                    <span>الحصة</span>
                                </div>
                            </div>
                            
                            <div className="attendance-table-body">
                                {attendanceData?.courses_by_category?.map((category, categoryIndex) => 
                                    category.courses.map((course, courseIndex) => (
                                        <div key={`${categoryIndex}-${courseIndex}`} className="attendance-table-row">
                                            <div className="table-cell date-cell">
                                                <FontAwesomeIcon icon={faCalendarCheck} className="date-icon" />
                                                <span>{course.enrollment_date ? 
                                                    new Date(course.enrollment_date).toLocaleString('ar-EG', {
                                                        year: 'numeric',
                                                        month: '2-digit',
                                                        day: '2-digit',
                                                        hour: '2-digit',
                                                        minute: '2-digit',
                                                        second: '2-digit'
                                                    }) : 
                                                    'غير محدد'
                                                }</span>
                                            </div>
                                            
                                            <div className="table-cell group-cell">
                                                <Badge className="group-badge">
                                                    <FontAwesomeIcon icon={faUserCheck} className="me-1" />
                                                    {attendanceData?.student?.group || 'غير محدد'}
                                                </Badge>
                                            </div>
                                            
                                            <div className="table-cell grade-cell">
                                                <FontAwesomeIcon icon={faGraduationCap} className="grade-icon" />
                                                <span className="grade-value">
                                                    {course.exam_grade ? `${course.exam_grade}` : '0'}
                                                </span>
                                            </div>
                                            
                                            <div className="table-cell progress-cell">
                                                <div className="progress-container">
                                                    <div className="progress-bar">
                                                        <div 
                                                            className="progress-fill" 
                                                            style={{width: `${course.progress || 0}%`}}
                                                        ></div>
                                                    </div>
                                                    <span className="progress-percentage">
                                                        {course.progress || 0}%
                                                    </span>
                                                </div>
                                            </div>
                                            
                                            <div className="table-cell type-cell">
                                                <Badge className="type-badge">
                                                    <FontAwesomeIcon icon={faUserTimes} className="me-1" />
                                                    {course.attendance_group && course.attendance_group.id === 1 ? 'أونلاين' : 'في السنتر'}
                                                </Badge>
                                            </div>
                                            
                                            <div className="table-cell status-cell">
                                                <Badge 
                                                    className={`status-badge ${course.attendance_status === 'حاضر' ? 'present' : 'absent'}`}
                                                >
                                                    <FontAwesomeIcon 
                                                        icon={course.attendance_status === 'حاضر' ? faCalendarCheck : faCalendarTimes} 
                                                        className="me-1" 
                                                    />
                                                    {course.attendance_status === 'حاضر' ? 'حاضر' : 'غائب'}
                                                </Badge>
                                            </div>
                                            
                                            <div className="table-cell session-cell">
                                                <FontAwesomeIcon icon={faGraduationCap} className="session-icon" />
                                                <span>{course.name}</span>
                                            </div>
                                        </div>
                                    ))
                                )}
                            </div>
                        </div>

                        {/* رسالة في حالة عدم وجود بيانات */}
                        {(!attendanceData?.courses_by_category || attendanceData.courses_by_category.length === 0) && (
                            <div className="no-content-container">
                                <div className="icon-wrapper-not">
                                    <span className="icon-line line-1"></span>
                                    <span className="icon-line line-2"></span>
                                </div>
                                <h2>لا توجد بيانات حضور متاحة</h2>
                                <p>لم يتم العثور على أي كورسات أو بيانات حضور.</p>
                            </div>
                        )}
                    </Container>
                </main>
            </div>
            <ScrollTopButton />
        </>
    );
}

export default ProfileAttendance;
